import 'reflect-metadata';

import { Container } from 'inversify';

import { InversifyContainer } from '../../shared/abstract/infrastructrue/Inversify.container';
import { AllTenantAgnosticUnifiedRolesQuery } from './application';
import { TenantQueryUseCase } from './application';
import { TenantHookService } from './application/Tenant.hook.service';
import { TenantService } from './application/Tenant.service';
import { TenantUIService } from './application/Tenant.ui.service';
import { SpecificTenantQuery } from './application/useCase/SpecificTenantQuery.useCase';
import { TenantUnifiedRolesQuery } from './application/useCase/TenantSpecificUnifiedRolesQuery.useCase';
import { TenantServiceClientAdapter } from './infrastructure/adapters/TenantServiceClientAdapter';
import { TenantController } from './infrastructure/controllers/Tenant.controller';
import { TenantHookController } from './infrastructure/controllers/Tenant.hook.controller';
import { TenantUIController } from './infrastructure/controllers/Tenant.ui.controller';
import { TenantComponentFactory } from './infrastructure/factories/Tenant.component.factory';
import { TenantFactory } from './infrastructure/factories/Tenant.factory';
import { TenantHookFactory } from './infrastructure/factories/Tenant.hook.factory';

export class TenantDomainContainer extends InversifyContainer {
  static create(): Container {
    return this.buildInversifyIOCContainer([
      TenantQueryUseCase,
      AllTenantAgnosticUnifiedRolesQuery,
      TenantService,
      TenantUnifiedRolesQuery,
      TenantUIService,
      TenantController,
      TenantUIController,
      TenantComponentFactory,
      TenantFactory,
      TenantHookController,
      TenantServiceClientAdapter,
      TenantHookService,
      TenantHookFactory,
      SpecificTenantQuery,
    ]);
  }
}
